export default class Tabs {
    constructor() {
        const tabWrappers = document.querySelectorAll(
            '[data-behaviour="tabs"]',
        );
        if (tabWrappers.length > 0) {
            tabWrappers.forEach((tabs) => {
                const wrapper = tabs;
                const toggles = tabs.querySelectorAll(
                    '[data-target="tab-toggle"]',
                );
                const targets = tabs.querySelectorAll('[data-id]');
                toggles.forEach((toggle) => {
                    toggle.addEventListener('click', (ev) => {
                        ev.preventDefault();
                        if (toggle.dataset.active == true) {
                            return false;
                        }
                        targets.forEach((target) => {
                            target.dataset.active = false;
                        });
                        const current_items = tabs.querySelectorAll(
                            '[data-id=' + toggle.dataset.id + ']',
                        );
                        current_items.forEach((item) => {
                            item.dataset.active = true;
                        });
                    });
                });
            });
        }
    }
}
